import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Upload } from "lucide-react";

interface FileUploadFieldProps {
  register: any;
  dragActive: boolean;
  onDragHandler: (e: React.DragEvent) => void;
}

export const FileUploadField = ({
  register,
  dragActive,
  onDragHandler,
}: FileUploadFieldProps) => {
  return (
    <div className="space-y-2">
      <Label>Any screenshots you'd like to add?</Label>
      <div
        className={`border-2 border-dashed rounded-lg p-8 text-center ${
          dragActive
            ? "border-primary bg-primary/5"
            : "border-input hover:border-primary/50"
        }`}
        onDragEnter={onDragHandler}
        onDragLeave={onDragHandler}
        onDragOver={onDragHandler}
        onDrop={onDragHandler}
      >
        <Input
          type="file"
          {...register("files")}
          className="hidden"
          id="file-upload"
          accept="image/*"
          multiple
        />
        <Label
          htmlFor="file-upload"
          className="cursor-pointer flex flex-col items-center gap-2"
        >
          <Upload className="h-8 w-8 text-muted-foreground" />
          <span className="text-sm text-muted-foreground">
            Click to choose a file or drag here
          </span>
          <span className="text-xs text-muted-foreground">Size limit: 10 MB</span>
        </Label>
      </div>
    </div>
  );
};